/**
 * Validate birth number
 *
 * @documented
 * @category BirthNumber
 * @import import { isBirthNumber } from '@gef-ui/validations/validationFunctions/birthNumber'
 * @param {Object} input
 * @param {boolean} [input.allowSlash=false] - allow slash in birth number
 * @param {boolean} [input.validateECP=true] - if falsy EČP will not be validated nothing will be subtracted from final day value
 * @param {boolean} [input.skipForeignerTest=false] - skip foreigner test
 * @param {boolean} [input.allowFakeGCPForeigner=false] - GPC creates fake birth number for foreigners by adding 20 to the month value. So foreign male will have 21-32 month and woman 71-82.
 * @returns {String} errMessage
 *
 */ function isBirthNumber({ allowSlash = false, validateECP = true, skipForeignerTest = false, allowFakeGCPForeigner = false } = {}) {
    return ({ fieldValue })=>{
        let result = 'birthNumberNotCorrect';
        if (fieldValue) {
            let value = fieldValue;
            const regex = new RegExp('^[0-9]{6}/[0-9]{3,4}$');
            const regex2 = new RegExp('^[0-9]{9,10}$');
            const regexInvalid = new RegExp('^[0]{9,10}$');
            const regexForeigner = new RegExp('^[0-9]{6}[9]{4}$');
            const actualYear = new Date().getFullYear();
            if (regex.test(value)) {
                if (allowSlash) {
                    value = value.replace('/', '');
                } else {
                    result = 'birthNumberContainsSlash';
                }
            }
            if (!skipForeignerTest && regexForeigner.test(value)) {
                const d = parseInt(value.substring(4, 6), 10);
                const m = parseInt(value.substring(2, 4), 10);
                if (d <= 31 && d > 0 && m <= 12 && m > 0) {
                    result = false;
                }
            } else if (regex2.test(value)) {
                if (!regexInvalid.test(value)) {
                    const ext = value.substring(6, 10);
                    let year = parseInt(value.substring(0, 2), 10);
                    if (ext.length === 4) {
                        year += year > 53 ? 1900 : 2000;
                    } else if (ext.length === 3) {
                        year += year > 53 ? 1800 : 1900;
                    }
                    let day = parseInt(value.substring(4, 6), 10);
                    let month = parseInt(value.substring(2, 4), 10);
                    if (allowFakeGCPForeigner && (month >= 21 && month <= 32 || month >= 71 && month <= 82)) {
                        month -= 20;
                    }
                    if (month > 70) {
                        month -= 70;
                    } else if (month > 50) {
                        month -= 50;
                    } else if (month > 20) {
                        month -= 20;
                    }
                    if (day > 40 && validateECP) {
                        day -= 40;
                    }
                    if (day > 0 && day <= 31 && month > 0 && month <= 12 && year <= actualYear) {
                        if (value.length === 10) {
                            const mod = parseInt(value.substring(0, 9), 10) % 11;
                            const last = parseInt(value.substring(9), 10);
                            if (mod === 10 && last === 0 || mod === last) {
                                result = false;
                            }
                        } else if (value.length === 9) {
                            result = false;
                        }
                    }
                }
            }
        }
        return result;
    };
}
export default {
    isBirthNumber
};
